import React from 'react';
import { Button } from 'react-bootstrap';
import _ from 'lodash';

export default function SaveButton(props) {
    const saveClicked = (event) => {
        event.preventDefault();
        if (props.clicked) { props.clicked(); }
    };

    let saveButtonIconClass = "fa fa-save button-icon";
    let saveButtonText = !_.isEmpty(props.text) ? props.text : "Save";

    if (props.saving) {
        saveButtonIconClass = "fa fa-spinner button-icon";
        saveButtonText = !_.isEmpty(props.savingText) ? props.savingText : "Saving...";
    }

    return (
        <Button
            bsStyle="danger"
            onClick={saveClicked}
            className={props.className}
            disabled={props.disabled}
            style={props.style}
        >
                <i className={saveButtonIconClass}></i>
                {saveButtonText}
        </Button>
    );
}
